// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"449":"80a206a1","811":"caef0b58","850":"ffd7a7b9","862":"73335aee","943":"7cc9162d"}[chunkId] + ".chunk.css";
};